exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ToolGroupButton{padding:0;white-space:nowrap;height:auto}.ToolGroupButton .Button{width:100%;padding:8px;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px;grid-row-gap:4px;row-gap:4px;color:var(--faded-text);cursor:pointer}.ToolGroupButton .Button:hover{background:var(--popup-button-hover)}.ToolGroupButton .Button.active{background:var(--popup-button-active);cursor:default}.ToolGroupButton .Button.active,.ToolGroupButton .Button.active .Icon{color:var(--view-header-icon-active-fill)}.ToolGroupButton.isFlyoutItem{display:flex}.ToolGroupButton.isFlyoutItem .Icon{display:none}", ""]);

// exports
